module.exports = __webpack_public_path__ + "img/196.7676fe34.jpg";